exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=file][data-v-105133ea]{border:none}", ""]);

// exports
